import { useEffect, useState } from 'react';
// Tailwind's default `sm` / `lg` min-width breakpoints, mirrored here because a class name cannot be
// read back at runtime.
const SM_QUERY = '(min-width: 640px)';
const LG_QUERY = '(min-width: 1024px)';
const resolveColumnCount = ({ base, sm, lg }) => {
    if (typeof window === 'undefined') {
        return base;
    }
    if (lg && window.matchMedia(LG_QUERY).matches) {
        return lg;
    }
    if (sm && window.matchMedia(SM_QUERY).matches) {
        return sm;
    }
    return base;
};
// How many columns a `grid-cols-{base} sm:grid-cols-{sm} lg:grid-cols-{lg}` grid renders right now.
// Virtualized grids chunk their items into rows, so they need the column count as a value instead of a
// class name. Backed by matchMedia change events rather than a resize listener, so it costs nothing
// while scrolling or resizing and only re-renders when a breakpoint is actually crossed. Starts at
// `base` so SSR and the first client render agree, then corrects in an effect after mount.
export const useGridColumnCount = (counts) => {
    const { base, sm, lg } = counts;
    const [columnCount, setColumnCount] = useState(base);
    useEffect(() => {
        const update = () => setColumnCount(resolveColumnCount({ base, sm, lg }));
        update();
        const queries = [window.matchMedia(SM_QUERY), window.matchMedia(LG_QUERY)];
        queries.forEach(query => query.addEventListener('change', update));
        return () => queries.forEach(query => query.removeEventListener('change', update));
    }, [base, sm, lg]);
    return columnCount;
};
